import React, { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../../api/axiosInstance";
import moment from "moment";
import "./tankProtokolle.scss"

const Tankprotokolle = () => {
    const [items, setItems] = useState([]);

    const fetchData = useCallback(async () => {
        try {
            const res = await axiosInstance.get("/tankstelle/log");
            setItems(res.data);
        } catch (err) {
            console.error(err);
        }
    }, []);

    useEffect(() => {
        fetchData();

        const interval = setInterval(() => {
            fetchData();
        }, 10000);

        return () => clearInterval(interval);
    }, [fetchData]);

    return (
        <div className="tankProtokolle">
            <div className="tableWrapper">
                <table>
                    <thead>
                        <tr>
                            <th>Transaktions Nr.</th>
                            <th>ID/Bezeichnung</th>
                            <th>Karten Nr.</th>
                            <th>Status</th>
                            <th>Getankt</th>
                            <th>Tankvorgang beendet</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((i) => (
                            <tr key={i.transactionId}>
                                <td>
                                    <bold>{i.transactionId}</bold>
                                </td>
                                <td>{i.identity} - {i.connectorId}</td>
                                <td>{i.idTag}</td>
                                <td className="tankstellenStatus">
                                    <div className={`grid ${i.status}`}>
                                        <div className="dot" />
                                        <bold>{i.status}</bold>
                                    </div>
                                </td>
                                <td>{i.meter && (i.meter / 1000).toLocaleString('de-DE') + " kW/h"}</td>
                                <td>{i.stoppedAt && moment(i.stoppedAt).fromNow()}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
};

export default Tankprotokolle